/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Supplyaircoolingsetpoint3Inputs */



/**
* | output |
* | --- |
* | "Supply air cooling setpoint" |
*
* @param {Ahu_History_Key_Supplyaircoolingsetpoint3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_supplyaircoolingsetpoint3 = /** @type {((inputs?: Ahu_History_Key_Supplyaircoolingsetpoint3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Supplyaircoolingsetpoint3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Supply air cooling setpoint")
	return /** @type {LocalizedString} */ ("Consigne froid air soufflé")
});
export { ahu_history_key_supplyaircoolingsetpoint3 as "ahu_history_key_supplyAirCoolingSetpoint" }